(function (scope) {
	'use strict';

	var PopUp = function (elementsOrSelector, mobile) {
		this.mobile = mobile;

		if (typeof elementsOrSelector === 'string') {
			this.$elements = $(elementsOrSelector);
		} else if (elementsOrSelector !== undefined) {
			this.$elements = elementsOrSelector;
		}
		
		if (this.$elements.length) {
			this.initialize();
		} else {
			console.warn('PopUp selector doesn\'t match any elements.');
		}
	};

	PopUp.prototype.initialize = function () {
		if (this.mobile) {
			this.$elements.addClass('mobile');
			var img = this.$elements.find('img');
			var src = img.data('mobile-src');
			img.attr('src', src);
		}

		this.isOpen = false;
		this.addEventHandlers();
	};

	PopUp.prototype.open = function (delay) {
		if (!this.isOpen) {
			if (delay && !isNaN(delay)) {
				this.clearTimeout();
				this.timeout = window.setTimeout(this.open.bind(this), delay);
			} else {
				this.$elements.addClass('open');
				this.isOpen = true;
			}
		}
	};

	PopUp.prototype.close = function () {
		this.clearTimeout();

		if (this.isOpen) {
			this.$elements.removeClass('open');
			this.isOpen = false;
		}
	};

	PopUp.prototype.clearTimeout = function () {
		if (this.timeout) {
			window.clearTimeout(this.timeout);
			this.timeout = null;
		}
	};

	PopUp.prototype.addEventHandlers = function () {
		this.handleClick = this.onClick.bind(this);
		this.$elements.on('click touchdown', this.handleClick);
	};

	PopUp.prototype.onClick = function (event) {
		var isLinkTarget = $(event.target).parents('a').length;
		// if (!isLinkTarget) {
			this.close();
		// }
	};

	scope.PopUp = PopUp;
})(window.Roots || (window.Roots = {}));
